var map = {
	"./data-search.de-CH.json": 986,
	"./data-search.de-DE.json": 987,
	"./data-search.en-CA.json": 988,
	"./data-search.en-GB.json": 989,
	"./data-search.en-IN.json": 990,
	"./data-search.en-ME.json": 991,
	"./data-search.en-US.json": 992,
	"./data-search.es-EM.json": 993,
	"./data-search.es-ES.json": 994,
	"./data-search.fr-BE.json": 995,
	"./data-search.fr-CA.json": 996,
	"./data-search.fr-CH.json": 997,
	"./data-search.nl-BE.json": 998,
	"./data-search.nl-NL.json": 999,
	"./data-search.pl-PL.json": 1000,
	"./data-search.pt-BR.json": 1001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 985;